import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareDistributeHorizontalIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 18 12' {...props}>
    <path
      d='M1 1h3v3H1V1zM0 0v5h5V0H0zM6 1h3v3H6V1zM5 0v5h5V0H5zM13 1h3v3h-3V1zm-1-1v5h5V0h-5zM4 11h1V9H4v2zm-4 0h1V9H0v2zm6 0h1V9H6v2zm6 0h1V9h-1v2zm-2 0h1V9h-1v2zm6-2v2h1V9h-1z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M1 1h3v3H1V1zM0 0v5h5V0H0zM7 1h3v3H7V1zM6 0v5h5V0H6zM13 1h3v3h-3V1zm-1-1v5h5V0h-5zM4 11h1V9H4v2zm-4 0h1V9H0v2zm6 0h1V9H6v2zm6 0h1V9h-1v2zm-2 0h1V9h-1v2zm6-2v2h1V9h-1z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const DistributeHorizontalIcon = memo(BareDistributeHorizontalIcon);
